(function ($, lo,eventHub) {
	'use strict';
	var pluginName = 'suggestPoints';
	var ghostClickElapsedTime = 50;
	var _lastEventTimestamp = 0;
	var defaults = {
		eventName        : 'select-sp',
		skeletonTemplate : '<table class="<%=classPrefix%> suggest-points noselect"><tr class="<%=classPrefix%> spoints"></tr><tr class="<%=classPrefix%> svalues"></tr></table>',
		classPrefix      : 'sp',
		onChange         : function (oldVal, newVal) {
			return oldVal + newVal;
		}
	};

	function Plugin(element, options) {
		this.element = element;
		this.value = null;
		this.options = $.extend({}, defaults, options);
		this.template = lo.template(this.options.skeletonTemplate);
		if (options && options.parser) {
			if (lo.isFunction(options.parser)) {
				this.parser = options.parser;
			}
		} else {
			this.parser = function (data) {
				return data;
			};
		}
		this.init();
	}

	Plugin.prototype.init = function () {
		this.classPrefix = lo.escape(this.options.classPrefix);
		this.listElm = $(this.template(this.options));
		this.sPoints = this.listElm.find('.' + this.classPrefix + '.spoints');
		this.sValues = this.listElm.find('.' + this.classPrefix + '.svalues');
		$(this.element).empty().append(this.listElm);
		var self = this;
		this.listElm.on('click tap', 'td', function () {
			var currentTime = (new Date()).getTime();
			if (currentTime - _lastEventTimestamp < ghostClickElapsedTime) {
				_lastEventTimestamp = currentTime;
				return true;
			}
			var selectedItemIdx = $(this).index();
			//remove all selected and make clicked selected
			self.sPoints.find('div').removeClass('selected');
			var selectedDiv = $(self.sPoints.find('td').get(selectedItemIdx)).find('div');
			selectedDiv.addClass('selected');
			// make bottom values selected too
			var valuesElm = self.sValues.children();
			valuesElm.removeClass('selected');
			$(valuesElm.get(selectedItemIdx)).addClass('selected');

			self.options.onChange(self.value, selectedDiv.data('value'));
			self.value = parseFloat(selectedDiv.data('value'));
			eventHub.publish('suggest-point-selected', [{'selectedValue':self.value}]);
			$('div', '[data-id="item_amount_1"]').text(self.value);
			_lastEventTimestamp = currentTime;
		});

		if (this.options.data) {
			this.setData(this.options.data);
		}
	};

	Plugin.prototype.setData = function (data) {
		this.options.data = this.parser(data || []);
		this.sPoints.empty();
		this.sValues.empty();
		if (this.options.order === 'asc'){
			this.options.data = lo.sortBy(this.options.data);
		}
		if (this.options.order === 'desc'){
			this.options.data = lo.sortBy(this.options.data).reverse();
		}
		lo.each(this.options.data, function (point) {
			this.sPoints.append('<td><div data-value="' + lo.escape(point) + '"></div></td>');
			this.sValues.append('<td>' + lo.escape(point) + '</td>');
		}, this);
		this.sPoints = this.listElm.find('.' + this.classPrefix + '.spoints');
		this.sValues = this.listElm.find('.' + this.classPrefix + '.svalues');
	};

	Plugin.prototype.setValue = function (value) {
		var index = lo.indexOf(this.options.data, value);
		if (index > -1) {
			this.options.onChange(this.value, value);
			this.value = value;
			this.sPoints.find('.selected').removeClass('selected');
			this.sValues.find('.selected').removeClass('selected');
			$(this.sPoints.children().get(index)).find('div').addClass('selected');
			$(this.sValues.children().get(index)).addClass('selected');
		}
		else {
			this.value = value;
			this.sPoints.find('.selected').removeClass('selected');
			this.sValues.find('.selected').removeClass('selected');
		}
	};
	Plugin.prototype.getValue = function () {
		return this.value;
	};
	$.fn[pluginName] = function (options) {
		return this.each(function () {
			if (!$.data(this, 'plugin_' + pluginName)) {
				$.data(this, 'plugin_' + pluginName, new Plugin(this, options));
			}
		});
	};
}(jQuery, _, pubsub));